/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currentplan1Inputs */

const en_currentplan1 = /** @type {(inputs: Currentplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan`)
};

const de_currentplan1 = /** @type {(inputs: Currentplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Plan`)
};

/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Currentplan1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const currentplan1 = /** @type {((inputs?: Currentplan1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currentplan1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_currentplan1(inputs)
	return de_currentplan1(inputs)
});
export { currentplan1 as "currentPlan" }